import React from "react";

export interface UserNameDisplayProps {
  userId: string | undefined;
  userName?: string | null;
}

/**
 * 表示専用: userId と（取得した）userName を受け取り、
 * "name(id)" / "id" / "-" のいずれかを表示する。
 */
export function UserNameDisplay({
  userId,
  userName,
}: UserNameDisplayProps): React.ReactElement {
  if (userId == null || userId === "") {
    return <>-</>;
  }
  if (userName != null && userName !== "") {
    return (
      <>
        {userName}(ID:{userId})
      </>
    );
  }
  return <>{userId}</>;
}
